import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=4150cac8&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"
import style0 from "./Stats.vue?vue&type=style&index=0&id=4150cac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150cac8",
  null
  
)

export default component.exports